// Generated using typescript-generator version null on 2019-08-20 09:17:48.

import {Observable} from 'rxjs/Rx';
import {Injectable} from '@angular/core';
import {HttpResponse} from "@angular/common/http";

export class TagLightDto implements Dto {
  libelle: string;
  code: string;
}

export class Response implements AutoCloseable {
  mediaType: MediaType;
  entity: any;
  lastModified: Date;
  date: Date;
  headers: any;
  allowedMethods: string[];
  cookies: { [index: string]: NewCookie };
  entityTag: EntityTag;
  links: Link[];
  stringHeaders: any;
  metadata: any;
  status: number;
  statusInfo: StatusType;
  length: number;
  language: Locale;
  location: URI;
}

export class SaveAlerteDto implements Dto {
  idDossier: string;
  email: string;
  telephone: string;
  heureEnvoiDebut: number;
  heureEnvoiFin: number;
}

export class IdsDto implements Dto {
  ids?: number[];
}

export class PaginateRequestDto {
  pageIndex: number;
  nbElementsParPage: number;
}

export class PaginateRequestWithTriDto<E> extends PaginateRequestDto {
  tri: E;
  asc: boolean;
}

export class RechercheDossierDto extends PaginateRequestWithTriDto<RechercheDossierTriEnum> implements Dto {
  dossierNomPrenom: string;
  jourNaissance: number;
  moisNaissance: number;
  anneeNaissance: number;
  laboratoires: CorrespondantDto[];
  laboratoiresTotal: CorrespondantDto[];
  medecins: CorrespondantDto[];
  medecinsTotal: CorrespondantDto[];
  debutDateCreation: any;
  finDateCreation: any;
  notDownloaded: boolean;
  examens: LigneCatalogueExamenDto[];
  etats: EtatDossierEnum[];
  status: StatutDossierEnum[];
}

export class DossierDto implements Dto {
  id: number;
  identifiant: string;
  nomPatient: string;
  nomJeuneFillePatient: string;
  prenomPatient: string;
  dateNaissancePatient: any;
  agePatientAnnee: number;
  flagGrossesse: boolean;
  pathologique: boolean;
  urgent: boolean;
  idDossierAntecedent: number;
  dateDernieresRegles: any;
  referenceLabo: string;
  identifiantLabo: string;
  referencePresc: string;
  sexePatient: SexePatientEnum;
  referencePatient: string;
  dateDossier: any;
  dateControle: any;
  dateValideComplet: any;
  dateSortiePrevisionnelle: any;
  dateFin: any;
  dateDernierTelechargement: any;
  datePrelevement: any;
  heurePrelevement: string;
  dateOrdonnance: any;
  statutDossier: StatutDossierEnum;
  resultatAnalyse: ResultatAnalyseDto;
  nomenclatures: NomenclatureDto[];
  analyse: AnalyseDto[];
  montantPatient: number;
  montantLabo: number;
  montantSS: number;
  montantMutuelle: number;
  montantAutre: number;
  identifiantMed1: string;
  nbDonneeManquante?: number;
  nbDocumentManquant?: number;
  dateDps?: any;
}

export class FileProperties implements Dto {
  fileExtensions?: string;
  fileMaxSize?: string;
}

export class DocumentInformation implements Dto {
  cleLigneAnalyseResultat?: string;
  codeCorrespondant?: string;
  numeroDossier?: string;
  action?: string;
}

export class CorrespondantDetailsDto {
  code: string;
  nom: string;
  adressePrincipale: AdresseDto;
  adresseLivraison: AdresseDto;
  telephone: string;
  fax: string;
  email: string;
  numFiness: string;
  numAdeli: string;
  codeRpps: string;
  typeCarte: string;
  correspondantParent: string;
}

export class UserInformations {
  id?: string;
  login?: string;
  prenom?: string;
  nom?: string;
  telephone?: string;
  role?: UserRole;
  metadata?: { [index: string]: any };
  lang?: Locale;
  modules?: string[];
  correspondants?: Correspondant[];
  date?: any;
  expires?: any;
  origine?: string;
  url?: string;
  codeRpps?: string;
  properties?: { [index: string]: any };
  'e-mail'?: string;
  daysBeforeExpire: number | undefined | null;
  firstConnection: boolean | undefined | null;
}

export class Profil {
  id?: number;
  libelle?: string;
  champs?: string;
}

export class UtilisateurPreferencesDto {
  id: number;
  login: string;
  page: PageEnum;
  type: TypePreferences;
  preferences: any;
}

export class AnalyseDto implements Dto {
  libelleAnalyseT: string;
  libelleAnalyseST: string;
  nature: string;
  dateCreation: any;
  statutExamen: string;
  dpsExamen: any;
  motif: string;
}

export class MediaType {
  type: string;
  subtype: string;
  parameters: { [index: string]: string };
  wildcardType: boolean;
  wildcardSubtype: boolean;
}

export class Cookie {
  name: string;
  value: string;
  version: number;
  path: string;
  domain: string;
}

export class NewCookie extends Cookie {
  comment: string;
  maxAge: number;
  expiry: Date;
  secure: boolean;
  httpOnly: boolean;
}

export class EntityTag {
  value: string;
  weak: boolean;
}

export class Link {
  rel: string;
  uriBuilder: UriBuilder;
  rels: string[];
  params: { [index: string]: string };
  title: string;
  uri: URI;
  type: string;
}

export interface StatusType {
  family: Family;
  statusCode: number;
  reasonPhrase: string;
}

export class Locale implements Cloneable, Serializable {
}

export class URI implements Comparable<URI>, Serializable {
}

export interface AutoCloseable {
}

export interface Dto {
}

export class LigneCatalogueExamenLightDto {
  id: number;
  locale: string;
  titre: string;
  sousTitre: string;
  codeOpenlab: string;
}

export class CorrespondantDto implements Dto {
  code: string;
  nom: string;
  tags: string[];
}

export class LigneCatalogueExamenDto {
  id: number;
  dateCreation: any;
  dateModification: any;
  locale: string;
  titre: string;
  sousTitre: string;
  nature: string;
  volume: string;
  temperature: TemperatureEnum;
  technique: string;
  frequence: string;
  delai: number;
  codesNabm: string;
  cotationsNabm: string;
  prixHorsNomenclature: number;
  specialite: string;
  prixFixe: boolean;
  creatinine: boolean;
  ententePrealable: boolean;
  consentement: boolean;
  conditionsTarifaires: string;
  synonymes: string[];
  url: string;
  lienGuide: string;
  commentaires: string;
  identifiantLcds: number;
  codeOpenlab: string;
  bioRespondable: string;
  favori: boolean;
  miseAJourRecente: boolean;
}

export class ResultatAnalyseDto implements Dto {
  lignes: LigneResultatAnalyseDto[];
}

export class NomenclatureDto implements Dto {
  identifiantDossier: string;
  numSeq: number;
  libelleFacture: string;
  codeNomenclature: string;
  lettre: string;
  nbPoints: number;
  prix: number;
}

export class DocumentDossierDto implements Dto {
  id: number;
  identifiantDossier: string;
  type: DocumentTypeEnum;
  name: string;
  mimeType: string;
  size: number;
}

export class DossierBloquerRequest {
  numeroDossier? : string;
  codeCorrespondant? :string;
  cleLigneAnalyseResultat? :string;
}

export class AbstractLongIdObject implements LongIdObject {
  id: number;
}

export class HistoriqueTelechargementDossierDto extends AbstractLongIdObject {
  identifiantDossier: string;
  filename: string;
  dateTelechargement: any;
  ip: string;
  username: string;
}

export class DossierBloqueDto implements Dto {
  id?: number;
  cleLigneAnalyseResultat?: string;
  codeAnalyseAAjouter?: string;
  codeCorrespondant?: string;
  langueCorrespondant?: string;
  libelleAnalyseResultat?: string;
  numeroDossier?: string;
  numeroEtiquettePrelevement?: string;
  typeAnomalie?: string;
  typeResultatAttendu?: string;
  seuilAlerteInf?: number;
  seuilAlerteSup?: number;
  resultatAnalyseSaisie?: string;
  resultatAnalyseConfirm?: boolean;
  dateHeureSaisie?: Date;
  codeCorrespondantSaisie?: string;
  etat?: string;
  codeList?: CodeDto[];
  nomFichier?: string;
  lock?: boolean;
  motifRejet?: string;
  visa?: string;
}

export class CodeDto implements Dto {
  cleLigneAnalyseResultat?: string;
  keyCode?: string;
  langueCorrespondant?: string;
  valueCode?: string;
}

export class PaginationResultDto implements Dto {
  limitExceeded: boolean;
  pagination: PaginationResult<LigneDossierDto>;
}

export class PaginationResult<T> {
  pageIndex: number;
  totalPages: number;
  totalElements: number;
  results: T[];
}

export class LigneDossierDto implements Dto {
  id: number;
  identifiant: string;
  referenceLabo: string;
  identifiantLabo: string;
  referencePresc: string;
  nomLaboratoire: string;
  nom: string;
  nomJeuneFille: string;
  prenom: string;
  dateNaissance: any;
  dateCreation: any;
  dateModification: any;
  statut: StatutDossierEnum;
  dateSortiePrevisionnelle: any;
  referencePatient: string;
  identifiantDossier: string;
  pathologique: boolean;
  urgent: boolean;
  identifiantMed1: string;
  complementDossierCount?: number;
  nbDonneeManquante?: number;
  nbDocumentManquant?: number;
}

export class HprimFaxMedecin {
  hprimFaxDto: HprimFaxDto;
  hasMedecin: boolean;
}

export class HprimFaxDto implements Dto {
  numDossier: string;
  numCorrespondant: string;
  userName: string;
  numFax: string;
  etat: EtatEmissionEnum;
  exemplaireMedecin: boolean;
}

export class EmissionDto implements Dto {
  etat: EtatEmissionEnum;
  numDossier: string;
}

export class EmissionHprimDebounceDto {
  debounceDelay: number;
  hprimEnabled: boolean;
  reemissionEnabled: boolean;
  examens: LigneCatalogueExamenLightDto[];
}



export class LaboratoireDto implements Dto {
  nomCompagnie: string;
  login: string;
  fax: string;
}

export class AdresseDto {
  ligne1: string;
  ligne2: string;
  ligne3: string;
  codePostal: string;
  ville: string;
  pays: string;
}

export class NotificationModuleDto implements Dto {
  id: number;
  titre: string;
  description: string;
}

export class Correspondant {
  code?: string;
  nom?: string;
  tags?: string[];
  dateDesactivation?: any;
  metadata?: { [index: string]: any };
}

export class UriBuilder {
}

export interface Cloneable {
}

export interface Serializable {
}

export class LigneResultatAnalyseDto {
  identifiantDossier: string;
  typeLigne1: TypeLigne1ResultatEnum;
  typeLigne2: TypeLigne2ResultatEnum;
  typeResultat: TypeResultatEnum;
  codeDestinataire: string;
  libelle: string;
  resultat: string;
  textCode: DatTextCodeDto[];
  nature: string;
  datePrelevement: any;
  code: string;
  unite: string;
  valeurReference: string;
  libelleCatalogue: string;
  numSeq: number;
  numSeq2: number;
  numLigne: number;
}

export interface Comparable<T> {
}

export class DatTextCodeDto {
  type: AbstractTextTypeEnum;
  data: any;
  sourceLineType: LineTypeEnum;
}

export class AnomalyFix {
  typeAnomalie: string;
  languageCode: string;
  numeroEtiquettePrelevement: string;
  cleLigneAnalyseResultat: string;
  codeAnalyseAAjouter: string;
  resultatAnalyse: string;
  codeMedecin: string;
  typeAnomalieCode: string;
}

export class ValidationResult {
  anomalyFix: AnomalyFix;
  statusCode: string;
  returnCode: number;
  returnMessage: string;
}

export interface LongIdObject {
  id: number;
}

export class ResultFixedAnomaliesDto {
  numeroDossier?: string;
  validationResults?: ValidationResultsDto[];
}

export class ValidationResultsDto {
  anomalyFix?: AnomalyFixDto;
  statusCode?: string;
  returnCode?: string;
  returnMessage?: string;
}

export class AnomalyFixDto {
  typeAnomalie?: string;
  languageCode?: string;
  numeroEtiquettePrelevement?: string;
  cleLigneAnalyseResultat?: string;
  codeAnalyseAAjouter?: string;
  resultatAnalyse?: string;
  codeMedecin?: string;
  typeAnomalieCode?: string;
}

export abstract class HttpClient {

  abstract request(requestConfig: { method: string; url: string; queryParams?: any; data?: any; }): RestResponse<any>;
}

@Injectable()
export class IAuditWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /info
   * Response code 200 - Le log a été ajouté avec succès
   * Response code 500 - Erreur interne lors du log d'audit
   * HTTP POST /audit/info
   * Java method: fr.cerba.digicerba.authentification.webservices.audit.IAuditWebService.info
   */
  info(queryParams?: { url?: string; message?: string; }): RestResponse<void> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`audit/info`, queryParams: queryParams });
  }
}

@Injectable()
export class IRessourceMultimediaWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /{id}
   * Response code 200 - Ressource multimedia récupérée avec succès
   * Response code 422 - Id null ou inconnu
   * Response code 500 - Erreur interne à la récupération du contenu
   * HTTP GET /ressourcemultimedia/{id}
   * Java method: fr.cerba.digicerba.resourcemultimedia.webservices.IRessourceMultimediaWebService.getRessourceMultimedia
   */
  getRessourceMultimedia(id: number): RestResponse<Response> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`ressourcemultimedia/${id}` });
  }
}

@Injectable()
export class IPurgeWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * enable
   * Response code 200 - Renvoi si la suppression est activée
   * HTTP POST /index/enable
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dev.es.IPurgeWebService.enable
   */
  enable(): RestResponse<boolean> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`index/enable` });
  }

  /**
   * purge
   * Response code 200 - Purge des indexes ES terminée
   * HTTP DELETE /index/purge
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dev.es.IPurgeWebService.purge
   */
  purge(): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`index/purge` });
  }

  /**
   * reindex
   * Response code 200 - Reindexation des données terminée
   * HTTP POST /index/reindex
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dev.es.IPurgeWebService.reindex
   */
  reindex(): RestResponse<void> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`index/reindex` });
  }
}

@Injectable()
export class IAlerteWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * alerte
   * Response code 200 - Alerte enregistrée
   * Response code 500 - Une erreur est survenue
   * HTTP POST /alerte/alerte
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IAlerteWebService.enregistrerAlerte
   */
  enregistrerAlerte(arg0: SaveAlerteDto): RestResponse<void> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`alerte/alerte`, data: arg0 });
  }

  /**
   * alerte
   * Response code 200 - Alertes enregistrées
   * Response code 500 - Une erreur est survenue
   * HTTP POST /alerte/alertes
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IAlerteWebService.enregistrerAlertes
   */
  enregistrerAlertes(arg0: SaveAlerteDto[]): RestResponse<void> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`alerte/alertes`, data: arg0 });
  }
}

@Injectable()
export class IBusWebServiceClient {
  constructor(protected httpClient: HttpClient) {}

  /**
   * Initialize DPS cache integration
   * HTTP GET /servicebus/apply/dps
   * Response code 200 - Initialization completed
   * Response code 403 - User not allowed
   * Response code 409 - Initialization failed
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossier.IBusWebService.applyDPS
   */
  applyDPS(): RestResponse<void> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`servicebus/apply/dps`});
  }
}

@Injectable()
export class IDossierWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * autocompletion
   * Response code 200 - Autocomplete terminée
   * HTTP GET /dossiers/autoCompleteExamen
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IDossierWebService.autoCompleteExamen
   */
  autoCompleteExamen(): RestResponse<LigneCatalogueExamenLightDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`dossiers/autoCompleteExamen` });
  }

  /**
   * documents/clean
   * Response code 200 - Nettoyage terminé
   * HTTP GET /dossiers/documents/clean
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IDossierWebService.cleanDocumentDossiers
   */
  cleanDocumentDossiers(): RestResponse<void> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`dossiers/documents/clean` });
  }

  /**
   * export
   * Response code 200 - Export terminé
   * HTTP POST /dossiers/export
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IDossierWebService.exportDossiersCSV
   */
  exportDossiersCSV(arg0: RechercheDossierDto): RestResponse<void> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`dossiers/export`, data: arg0 });
  }

  /**
   * exportFacturation
   * Response code 200 - Export terminé
   * HTTP POST /dossiers/exportFacturation
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IDossierWebService.exportFacturationCSV
   */
  exportFacturationCSV(arg0: RechercheDossierDto): RestResponse<void> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`dossiers/exportFacturation`, data: arg0 });
  }

  /**
   * findById/{id}
   * Response code 200 - Récuperation du dossier par id
   * HTTP GET /dossiers/findById/{id}
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IDossierWebService.findById
   */
  findById(id: number): RestResponse<DossierDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`dossiers/findById/${id}` });
  }

  /**
   * documents/{id}
   * Response code 200 - Récupération terminé
   * Response code 422 - Id null ou inconnu
   * Response code 500 - Erreur interne à la récupération des documents
   * HTTP GET /dossiers/documents/{id}
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IDossierWebService.findDocumentDossiers
   */
  findDocumentDossiers(id: string): RestResponse<DocumentDossierDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`dossiers/documents/${id}` });
  }

  /**
   * historiqueDownload/{id}
   * Response code 200 - Récupération terminé
   * Response code 422 - Id null ou inconnu
   * Response code 500 - Erreur interne à la récupération des documents
   * HTTP GET /dossiers/historiqueDownload/{id}
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IDossierWebService.findHistoriqueTelechargementDossier
   */
  findHistoriqueTelechargementDossier(id: string): RestResponse<HistoriqueTelechargementDossierDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`dossiers/historiqueDownload/${id}` });
  }

  /**
   * fixeranomalie
   * Response code 200 - Listes des anomalies après traitement, renvoie notamment un statut OK ou KO
   * HTTP POST /dossiers/fixeranomalie
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IDossierWebService.fixerAnomalies
   */
  fixerAnomalies(arg0: DossierBloqueDto[]): RestResponse<ResultFixedAnomaliesDto> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`dossiers/fixeranomalie`, data: arg0 });
  }

  /**
   * fixeranomalie
   * Response code 200 - Listes des anomalies après traitement, renvoie notamment un statut OK ou KO
   * HTTP POST dossierbloque/fixDocumentAnomalies
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.IDossierBloqueWebService.appelFixedCerbaAnomalies
   */
  fixDocumentAnomalies(dossierBloqueDto: DossierBloqueDto, file: File): RestResponse<ResultFixedAnomaliesDto> {
    const formData = new FormData();
    formData.append('file', file);
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`dossiers/document/fixanomalies/${dossierBloqueDto.numeroDossier}/${dossierBloqueDto.cleLigneAnalyseResultat}/${dossierBloqueDto.codeCorrespondant}/${dossierBloqueDto.nomFichier}`,
      data: formData
    });
  }

  /**
   * Response code 200 - Récuperation des anomalies d'un dossier
   * HTTP GET /dossiers/detail/{numerodossier}/etat/{etat}
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IDossierWebService.getDetailDossierBloqueByNumeroDossier
   */
  getDetailsByNumeroDossierAndEtat(numerodossier: string, etat: EtatEnum): RestResponse<DossierBloqueDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`dossiers/detail/${numerodossier}/etat/${etat}` });
  }

  /**
   * document/{id}
   * Response code 200 - Téléchargement terminé
   * Response code 422 - Id null ou inconnu
   * Response code 500 - Erreur interne à la récupération du contenu
   * HTTP GET /dossiers/document/{id}
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IDossierWebService.getDocumentDossierContent
   */
  getDocumentDossierContent(id: number): RestResponse<void> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`dossiers/document/${id}` });
  }

  /**
   * mail/{id}
   * Response code 200 - Mail envoyé
   * HTTP GET /dossiers/mail/{id}
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IDossierWebService.mailDossier
   */
  mailDossier(id: number): RestResponse<void> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`dossiers/mail/${id}` });
  }

  /**
   * rechercher
   * Response code 200 - Recherche terminée
   * HTTP POST /dossiers/rechercher
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IDossierWebService.rechercheDossiers
   */
  rechercheDossiers(arg0: RechercheDossierDto): RestResponse<PaginationResultDto> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`dossiers/rechercher`, data: arg0 });
  }

    /**
   * message-retard/{id}
   * Response code 200 - Messages trouvés
   * HTTP GET message-retard/{id}
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IDossierWebService.messageRetard
   */
  messageRetard(id : string): RestResponse<string[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`dossiers/message-retard/${id}`});
  }

  /**
   * fileproperties
   * Response code 200 - Récuperation des extensions et de la taille d'un fichier pour un document
   * HTTP GET dossiers/document/fileproperties
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IDossierWebService.fileproperties
   */
  getFileProperties(): RestResponse<FileProperties> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`dossiers/document/fileproperties`,
    });
  }

  /**
   * deleteFileDossierBloque
   * Response code 200 - download file
   * HTTP GET dossiers/document/document/delete/{numeroDossier}/{cleLigneAnalyseResultat}/{codeCorrespondant}
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IDossierWebService.deleteDocumentAnomaly
   */
  deleteFileDossierBloque(dossierBloqueDto: DossierBloqueDto){
    return this.httpClient.request({
      method: 'POST',
      url: uriEncoding`dossiers/document/delete/${dossierBloqueDto.numeroDossier}/${dossierBloqueDto.cleLigneAnalyseResultat}/${dossierBloqueDto.codeCorrespondant}`
    });
  }

  /**
   * downloadFile
   * Response code 200 - download file
   * HTTP GET dossiers/document/download
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IDossierWebService.downloadFile
   */
  downloadFile(documentRequest : DossierBloquerRequest ): RestResponse<HttpResponse<Blob>>{
    return this.httpClient.request({
      method: 'POST-BLOB',
      url: uriEncoding`dossiers/document/download`,
      data : documentRequest
    });
  }

  /**
   * Analysis filters
   * Response code 200 - Get analysis filters
   * HTTP GET /dossiers/analysis/filters
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IDossierWebService.getAnalysisFilters
   */
  getAnalysisFilters(): RestResponse<String[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`dossiers/analysis/filters` });
  }
}

@Injectable()
export class IEmissionWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /hprim/isConnect
   * Response code 200 -
   * HTTP POST /emission/hprim/isConnect
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IEmissionWebService.estConnecteHprim
   */
  estConnecteHprim(arg0: HprimFaxDto[]): RestResponse<string[]> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`emission/hprim/isConnect`, data: arg0 });
  }

  /**
   * {id}
   * HTTP GET /emission/{id}
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IEmissionWebService.etat
   */
  etat(id: number): RestResponse<EmissionDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`emission/${id}` });
  }

  /**
   * /fax
   * Response code 200 -
   * HTTP POST /emission/fax
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IEmissionWebService.fax
   */
  fax(arg0: HprimFaxDto[]): RestResponse<number> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`emission/fax`, data: arg0 });
  }

  /**
   * /hprim
   * Response code 200 -
   * HTTP POST /emission/hprim
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IEmissionWebService.hprim
   */
  hprim(arg0: HprimFaxDto[]): RestResponse<number> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`emission/hprim`, data: arg0 });
  }

  /**
   * /hprim/isEnabled
   * Response code 200 -
   * HTTP GET /emission/hprim/isEnabled
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IEmissionWebService.isHPrimEnabled
   */
  isHPrimEnabled(): RestResponse<boolean> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`emission/hprim/isEnabled` });
  }

  /**
   * /hprim/isInTags
   * Response code 200 -
   * HTTP GET /emission/hprim/isInTags
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IEmissionWebService.isHprimInTags
   */
  isHprimInTags(): RestResponse<boolean> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`emission/hprim/isInTags` });
  }

  /**
   * /reemission/isEnabled
   * Response code 200 -
   * HTTP GET /emission/reemission/isEnabled
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IEmissionWebService.isReemissionEnabled
   */
  isReemissionEnabled(): RestResponse<boolean> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`emission/reemission/isEnabled` });
  }

  /**
   * /getEnabledDebounceDelay
   * Response code 200 -
   * HTTP GET /emission/getEnabledDebounceDelay
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.IEmissionWebService.getHprimReemissionDebounce
   */
  getEnabledDebounceExamen(): RestResponse<EmissionHprimDebounceDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`emission/getEnabledDebounceDelay` });
  }
}

@Injectable()
export class ILaboratoireWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * identifiants
   * Response code 200 -
   * HTTP POST /laboratoires/identifiants
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.dossiers.ILaboratoireWebService.findByIdentifiants
   */
  findByIdentifiants(arg0: string[]): RestResponse<LaboratoireDto[]> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`laboratoires/identifiants`, data: arg0 });
  }
}

@Injectable()
export class IImportDocumentDossierWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * import
   * Response code 200 - Import terminé
   * HTTP GET /importDocuments/import
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.imports.IImportDocumentDossierWebService.importDocuments
   */
  importDocuments(): RestResponse<void> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`importDocuments/import` });
  }
}

@Injectable()
export class IIntegrationFichierDATWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * importAnneeType
   * Response code 200 - Import terminé
   * HTTP GET /importdat/importAnneeType
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.imports.IIntegrationFichierDATWebService.importAnneeType
   */
  importAnneeType(queryParams?: { cheminSource?: string; type?: TypeImportEnum; annee?: number; }): RestResponse<void> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`importdat/importAnneeType`, queryParams: queryParams });
  }

  /**
   * import
   * Response code 200 - Import terminé
   * HTTP GET /importdat/import
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.imports.IIntegrationFichierDATWebService.importFichierDat
   */
  importFichierDat(): RestResponse<void> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`importdat/import` });
  }

  /**
   * importJour
   * Response code 200 - Import terminé
   * HTTP GET /importdat/importJour
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.imports.IIntegrationFichierDATWebService.importJour
   */
  importJour(queryParams?: { cheminSource?: string; type?: TypeImportEnum; annee?: number; mois?: number; jour?: number; }): RestResponse<void> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`importdat/importJour`, queryParams: queryParams });
  }

  /**
   * importMois
   * Response code 200 - Import terminé
   * HTTP GET /importdat/importMois
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.imports.IIntegrationFichierDATWebService.importMois
   */
  importMois(queryParams?: { cheminSource?: string; type?: TypeImportEnum; annee?: number; mois?: number; }): RestResponse<void> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`importdat/importMois`, queryParams: queryParams });
  }

  /**
   * importTotal
   * Response code 200 - Import terminé
   * HTTP GET /importdat/importTotal
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.imports.IIntegrationFichierDATWebService.importTotal
   */
  importTotal(queryParams?: { cheminSource?: string; }): RestResponse<void> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`importdat/importTotal`, queryParams: queryParams });
  }

  /**
   * importTotalType
   * Response code 200 - Import terminé
   * HTTP GET /importdat/importTotalType
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.imports.IIntegrationFichierDATWebService.importType
   */
  importType(queryParams?: { cheminSource?: string; type?: TypeImportEnum; }): RestResponse<void> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`importdat/importTotalType`, queryParams: queryParams });
  }

  /**
   * Response code 204 - Import terminé
   * HTTP GET /importdat/notifier
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.imports.IIntegrationFichierDATWebService.notifierCompletionDossiers
   */
  notifierCompletionDossiers(): RestResponse<void> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`importdat/notifier` });
  }
}

@Injectable()
export class IReindexationWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * reindex
   * Response code 200 - Réindexation terminée
   * HTTP POST /es/reindex
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.imports.IReindexationWebService.reindex
   */
  reindex(): RestResponse<void> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`es/reindex` });
  }

  /**
   * reindex
   * Response code 200 - Réindexation terminée
   * HTTP POST /es/reindex/{id}
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.imports.IReindexationWebService.reindexDossier
   */
  reindexDossier(id: string): RestResponse<void> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`es/reindex/${id}` });
  }
}

@Injectable()
export class INotificationServeurResultatsWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * count
   * Response code 200 - Retourne les notifications de serveur de résultats
   * Response code 500 - Impossible de retourner les notifications
   * HTTP GET /notification/count
   * Java method: fr.cerba.digicerba.serveurresultats.webservices.notifications.INotificationServeurResultatsWebService.countNotificationsResultats
   */
  countNotificationsResultats(): RestResponse<number> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`notification/count` });
  }
}

@Injectable()
export class ICorrespondantWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /tags
   * Response code 200 - Retourne les tags du correspondant courant
   * Response code 500 - Erreur interne à la récupération des informations
   * HTTP GET /correspondant/tags/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getAllTags
   */
  getAllTags(): RestResponse<string[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`correspondant/tags/all` });
  }

  /**
   * /
   * Response code 200 - Retourne le détail des infos d'un correspondant
   * Response code 500 - Erreur interne à la récupération des informations
   * HTTP GET /correspondant/{code}/details
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getCorrespondantDetails
   */
  getCorrespondantDetails(code: string): RestResponse<CorrespondantDetailsDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`correspondant/${code}/details` });
  }

  /**
   * /
   * Response code 200 - Retourne la liste des correspondant de l'utilisateur courant avec succès
   * Response code 500 - Erreur interne à la récupération des informations
   * HTTP GET /correspondant/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getCorrespondants
   */
  getCorrespondants(): RestResponse<CorrespondantDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`correspondant/all` });
  }

  /**
   * /tags
   * Response code 200 - Retourne les tags du correspondant courant
   * Response code 500 - Erreur interne à la récupération des informations
   * HTTP GET /correspondant/tags
   * Java method: fr.cerba.digicerba.shared.webservices.user.ICorrespondantWebService.getTags
   */
  getTags(): RestResponse<string[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`correspondant/tags` });
  }
}

@Injectable()
export class IDebounceServiceClient {
  constructor(protected httpClient: HttpClient) {

  }

  getDebounce(): RestResponse<number> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`debounce/delay`});
  }
}

@Injectable()
export class INotificationsCommonWebServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * messages/count
     * HTTP GET /notification/messages/count
     * Java method: fr.cerba.digicerba.shared.webservices.user.INotificationsCommonWebService.countMessageNotifications
     */
    countMessageNotifications(): RestResponse<number> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`notification/messages/count` });
    }

    /**
     * messages/count
     * HTTP GET /notification/messages/module
     * Java method: fr.cerba.digicerba.shared.webservices.user.INotificationsCommonWebService.getMessageNotificationsModule
     */
    getMessageNotificationsModule(): RestResponse<NotificationModuleDto[]> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`notification/messages/module` });
    }

  /**
   * messages/module/markAsRead
   * Response code 204 - Notifications lues
   * Response code 500 - Impossible de mettre au statut lues les notifications
   * HTTP PUT /notification/messages/module/markAsRead
   * Java method: fr.cerba.digicerba.shared.webservices.user.INotificationsCommonWebService.markAsReadMessageNotifications
   */
  markAsReadMessageNotifications(arg0: IdsDto): RestResponse<number> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`notification/messages/module/markAsRead`, data: arg0 });
  }
}

@Injectable()
export class ITechnicWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /correspondant/all
   * Response code 200 - Retourne les correspondants actifs
   * Response code 500 - Erreur interne à la récupération des informations
   * HTTP GET /technic/correspondants/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ITechnicWebService.getCorrespondants
   */
  getCorrespondants(): RestResponse<CorrespondantDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`technic/correspondants/all` });
  }

  /**
   * /tags/all
   * Response code 200 - Retourne les tags actifs
   * Response code 500 - Erreur interne à la récupération des informations
   * HTTP GET /technic/tags/all
   * Java method: fr.cerba.digicerba.shared.webservices.user.ITechnicWebService.getTags
   */
  getTags(queryParams?: { locale?: string; }): RestResponse<TagLightDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`technic/tags/all`, queryParams: queryParams });
  }

  /**
   * /tags/all
   * Response code 200 - Retourne les tags actifs pour une catégorie
   * Response code 500 - Erreur interne à la récupération des informations
   * HTTP GET /technic/tags/byCategorie
   * Java method: fr.cerba.digicerba.shared.webservices.user.ITechnicWebService.getTagsByCategorie
   */
  getTagsByCategorie(queryParams?: { locale?: string; categorie?: string; }): RestResponse<string[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`technic/tags/byCategorie`, queryParams: queryParams });
  }
}

@Injectable()
export class IUserInformationsWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * /check
   * Response code 200 - Retourne true si le module est accessible
   * Response code 401 - Le module n'est pas accessible
   * HTTP GET /check
   * Java method: fr.cerba.digicerba.shared.webservices.user.IUserInformationsWebService.checkAccess
   */
  checkAccess(): RestResponse<boolean> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`check` });
  }

  /**
   * /
   * Response code 200 - Retourne les informations de l'utilisateur avec succès
   * Response code 500 - Erreur interne à la récupération des informations
   * HTTP GET /me
   * Java method: fr.cerba.digicerba.shared.webservices.user.IUserInformationsWebService.me
   */
  me(): RestResponse<UserInformations> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`me` });
  }
}

@Injectable()
export class IUtilisateurPreferencesWebServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * createPreferences
   * Response code 200 - Création du filtre terminée
   * HTTP POST /utilisateurPreferences/createPreferences
   * Java method: fr.cerba.digicerba.userpreferences.webservices.IUtilisateurPreferencesWebService.createUserPreferences
   */
  createUserPreferences(arg0: UtilisateurPreferencesDto): RestResponse<UtilisateurPreferencesDto> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`utilisateurPreferences/createPreferences`, data: arg0 });
  }

  /**
   * userPreferences
   * Response code 200 - Récuperation des preferences terminé
   * HTTP GET /utilisateurPreferences/get/{type}/{page}
   * Java method: fr.cerba.digicerba.userpreferences.webservices.IUtilisateurPreferencesWebService.getUserPreferences
   */
  getUserPreferences(type: TypePreferences, page: PageEnum): RestResponse<UtilisateurPreferencesDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`utilisateurPreferences/get/${type}/${page}` });
  }

  /**
   * updatePreferences
   * Response code 200 - Mise à jour du filtre terminée
   * HTTP POST /utilisateurPreferences/updatePreferences
   * Java method: fr.cerba.digicerba.userpreferences.webservices.IUtilisateurPreferencesWebService.updateUserPreferences
   */
  updateUserPreferences(arg0: UtilisateurPreferencesDto): RestResponse<UtilisateurPreferencesDto> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`utilisateurPreferences/updatePreferences`, data: arg0 });
  }
}

@Injectable()
export class IConfigWebServiceClient {
  constructor(protected httpClient: HttpClient) {
  }

  /**
   * HTTP GET /config/getComplementDossierApiUri
   * Java method: fr.cerba.digicerba.shared.webservices.config.IConfigWebService.getComplementDossierApiUri
   */
  getComplementDossierApiUri(): RestResponse<string[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`config/getComplementDossierApiUri` });
  }

  /**
   * HTTP GET /config/getComplementDossierFrontUri
   * Java method: fr.cerba.digicerba.shared.webservices.config.IConfigWebService.getComplementDossierFrontUri
   */
  getComplementDossierFrontUri(): RestResponse<string[]> {
    return this.httpClient.request({method: 'GET', url: uriEncoding`config/getComplementDossierFrontUri`});
  }
}

export type RestResponse<R> = Observable<R>;

export type EtatEnum = 'EN_COURS' | 'TERMINE' | 'EN_ATTENTE' | 'A_VALIDER';

export type EtatDossierEnum = 'PATHOLOGIQUE' | 'URGENT';

export type StatutDossierEnum = 'ENREGISTRE' | 'EN_CONTROLE' | 'VALIDE_COMPLET' | 'VALIDE_PARTIEL' | 'TERMINE';

export type SexePatientEnum = 'HOMME' | 'FEMME';

export type UserRole = 'COMPTE_LIE' | 'INVITE' | 'ANCIEN_COMPTE' | 'ADMINISTRATEUR' | 'RESPONSABLE' | 'MODULE' | 'PROSPECT';

export type PageEnum = 'SERVEUR_RESULTATS';

export type TypePreferences = 'FILTRES';

export type Family = 'INFORMATIONAL' | 'SUCCESSFUL' | 'REDIRECTION' | 'CLIENT_ERROR' | 'SERVER_ERROR' | 'OTHER';

export type TemperatureEnum = 'AMBIANT' | 'REFRIGERE' | 'CONGELE';

export type RechercheDossierTriEnum = 'DATE_CREATION' | 'DATE_PREVISIONELLE' | 'DATE_MODIFICATION';

export type DocumentTypeEnum = 'HONORAIRE' | 'MEDECIN' | 'PATIENT' | 'LABORATOIRE';

export type EtatEmissionEnum = 'EN_COURS' | 'TERMINE' | 'TERMINE_EN_COURS' | 'ERREUR' | 'DEJA_EMIS' | 'FAX_REQUIS';

export type TypeLigne1ResultatEnum = 'TITRE' | 'LIBELLE' | 'LIBELLE_RESULTAT' | 'RESULTAT';

export type TypeLigne2ResultatEnum = 'CHAPITRE' | 'SOUS_CHAPITRE' | 'PRELEVEMENT' | 'RESULTAT_A' | 'VALEUR_REFERENCE_A' | 'RESULTAT_B' | 'VALEUR_REFERENCE_B' | 'TEXTE_COMMENTAIRE' | 'TEXTE_LIBRE' | 'SIGNATURE';

export type TypeResultatEnum = 'TEXTE_CODE' | 'TEXTE_LIBRE' | 'NORME_CODEE' | 'BMD_CLA' | 'TABLEAU';

export type AbstractTextTypeEnum = 'COMMENTAIRE' | 'HORIZONTAL_TABLE' | 'VERTICAL_TABLE' | 'NORME';

export type LineTypeEnum = 'LABORATOIRE' | 'MEDECIN' | 'PATIENT' | 'ENTETE_DOSSIER' | 'RESULTAT_ANALYSE' | 'COMMENTAIRE' | 'TEXT_LIBRE' | 'NORME' | 'SUPPRIMER_MEDECIN_CORRESPONDANT' | 'NOMENCLATURE' | 'DATE_SORTIE' | 'ETAT_DOSSIER' | 'SUPPRIMER_DOSSIER' | 'TABLEAU' | 'PATHOLOGIQUE' | 'URGENT';

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
  let result = '/serveur-resultats/api/';
  for (let i = 0; i < substitutions.length; i++) {
    result += template[i];
    result += encodeURIComponent(substitutions[i]);
  }
  result += template[template.length - 1];
  return result;
}

export type TypeImportEnum = 'BIOLOGIE';





// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/common/resources/resources.ts